import { CalendarClock, CalendarDays, Repeat } from "lucide-react";
import EnquiryForm from "./EnquiryForm";
import { Reveal } from "./Motion";
import { BULK_PRODUCTS, MOBILE_ATTRS, QTY_UNITS } from "../lib/leadFields";

const today = () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);
const FIELDS = [
  { name: "name", label: "Full Name", required: true, attrs: { minLength: 2, autoComplete: "name" } },
  { name: "company", label: "Company Name", attrs: { autoComplete: "organization" } },
  { name: "phone", label: "Mobile Number", type: "tel", required: true, placeholder: "10-digit mobile number", attrs: MOBILE_ATTRS },
  { name: "email", label: "Email Address", type: "email", attrs: { autoComplete: "email" } },
  { name: "product", label: "Product", type: "select", required: true, full: true, options: BULK_PRODUCTS },
  { name: "quantity", label: "Quantity per Delivery", type: "number", required: true, placeholder: "e.g. 500", attrs: { min: 1, step: 1 } },
  { name: "quantity_unit", label: "Unit", type: "select", required: true, options: QTY_UNITS },
  { name: "frequency", label: "Repeat Frequency", type: "select", required: true, options: ["Weekly", "Fortnightly", "Monthly"] },
  { name: "delivery_day", label: "Preferred Delivery Day", type: "select", options: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday", "Any day"] },
  { name: "start_date", label: "First Delivery Date", type: "date", required: true, attrs: { min: today() } },
  { name: "delivery_time", label: "Preferred Delivery Time", type: "select", options: ["Morning", "Afternoon", "Evening", "Any time"] },
  { name: "city", label: "Delivery Location", required: true, full: true, placeholder: "Town / city, district" },
  { name: "message", label: "Additional Requirements", type: "textarea", full: true, placeholder: "Vehicles in your fleet, site contact, unloading instructions…" },
];
const POINTS = [
  [Repeat, "Weekly, fortnightly or monthly", "Pick the supply cycle that matches your fleet's DEF consumption."],
  [CalendarDays, "Your delivery schedule", "Choose the first delivery date and your preferred day and time."],
  [CalendarClock, "Confirmed by our team", "We call you to confirm pricing and the schedule before the first supply."],
];
const WA = "Hello MHM SUPER ADBLUE, I would like to set up a repeat DEF / AdBlue supply.";

export default function RepeatOrderSection() {
  return (
    <section id="repeat-order" data-testid="repeat-order-section" className="bg-white py-16 md:py-24">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-4">
          <p className="eyebrow text-brand">Repeat order</p>
          <h2 className="mt-3 font-display text-4xl font-extrabold uppercase text-navy md:text-5xl">Set up regular supply</h2>
          <p className="mt-4 text-slate-600">For regular fleet customers — request a repeat DEF / AdBlue supply on a fixed schedule instead of ordering every time.</p>
          <ul className="mt-8 space-y-3">
            {POINTS.map(([Icon, t, d]) => (
              <li key={t} className="flex gap-4 rounded-2xl border border-navy/10 bg-[var(--paper)] p-5">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-navy text-brand"><Icon className="h-5 w-5" /></span>
                <span><span className="block font-display text-xl font-bold uppercase text-navy">{t}</span><span className="text-sm text-slate-600">{d}</span></span>
              </li>
            ))}
          </ul>
        </div>
        <Reveal delay={0.1} className="lg:col-span-8">
          <div className="clip-notch rounded-[26px] border border-navy/10 bg-[var(--paper)] p-6 sm:p-10">
            <EnquiryForm type="bulk" testPrefix="repeat-order" fields={FIELDS} extraDetails={{ Form: "Repeat order" }} submitLabel="Request repeat supply"
              waText={WA} successText="Your repeat order request has been received. Our team will call you to confirm pricing and your delivery schedule." />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
